<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-inexorange hover:text-white" :href="route('divisas')">Divisa</inertia-link>
      <span class="text-white font-medium">-    {{ form.name}}
      </span>
    </h1>
    <trashed-message v-if="divisa.deleted_at" class="mb-6" @restore="restore">
     Cliente  Eliminado!
    </trashed-message>
    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.nombres" class="pr-6 pb-8 w-full lg:w-2/3" label="Nombres" required/>
          <select-input v-model="form.status" :error="form.errors.status" class="pr-6 pb-8 w-full lg:w-1/3" label="Activo" required>
            <option>SI</option>
            <option>NO</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-transparent flex justify-between items-center">
          <button v-if="!divisa.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Cliente</button>          
          <loading-button :loading="form.processing" style="color: white" class="px-8 py-4 btn-indigoOrange" type="submit">Actualizar Cliente</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.name}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    divisa: Object,
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.divisa.name,
        status: this.divisa.status,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('divisas.update', this.divisa.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('divisas.destroy', this.divisa.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('divisas.restore', this.divisa.id))
      }
    },
  },
}
</script>
